export default __webpack_public_path__ + "static/bitcoin-908187928853b9c75271df04557fdc72.svg";